export const siteSettings = {
  name: "Elite Pro Capital",
  link: "https://eliteprocapital.net/",
  email: "support@eliteprocapital.net/",
  appLink: "https://app.eliteprocapital.net/",
};
